import { MainComponent } from './main/main.component';
import { HomeComponent } from './home/home.component';
import { LogInComponent } from './login/login.component';
import { ChartComponent } from './chart/chart.component';
import { FilterComponent } from './filter/filter.component';
import { CustomerComponent } from './customer/customer.component';
import { MachinesComponent } from './machines/machines.component';
import { CardComponent } from './card/card.component';
import { SettingsComponent } from './settings/settings.component';
import { DataStudioReportComponent } from './data-studio-report/data-studio-report.component';
import { UserMngtComponent } from './user-mngt/user-mngt.component';
import { AgentMngtComponent } from './agent-mngt/agent-mngt.component';
import { MachineInfoComponent } from './machine-info/machine.info.component';
import { MachineMngtComponent } from './machine-mngt /machine-mngt.component';
import { CustomerMngtComponent } from './customer-mngt/customer-mngt.component';
import { MachineTotalsComponent } from './machine-totals/machine.totals.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { UserMngtDetailComponent } from './user-mngt-detail/user-mngt-detail.component';
import { MachineDailyWorksComponent } from './machine-works/machine.daily.works.component';
import { AgentMngtDetailComponent } from './agent-mngt-detail/agent-mngt-detail.component';
import { MachineTotalJobsComponent } from './machine-total-jobs/machine.total.jobs.component';
import { MachineMngtDetailComponent } from './machine-mngt-detail/machine-mngt-detail.component';
import { CircularPercentageComponent } from './circular-percentage/circular.percentage.component';
import { AgentPwdGenDialogComponent } from './agent-pwd-gen-dialog/agent-pwd-gen-dialog.component';
import { CustomerMngtDetailComponent } from './customer-mngt-detail/customer-mngt-detail.component';
import { OperatorMngtComponent } from './operator-mngt/operator-mngt.component';
import { OperatorMngtDetailComponent } from './operator-mngt-detail/operator-mngt-detail.component';
import { ViewImgDialogComponent } from './view-img-dialog/view-img-dialog.component';
import { VersionInfoComponent } from './version-info/version-info.component';
import { FooterComponent } from './footer/footer.component';
import { EnvInfoComponent } from './env-info/env-info.component';
import { JobOrdersComponent } from './job-orders/job-orders.component';
import { JobOrderDetailComponent } from './job-order-detail/job-order-detail.component';
import { JobOrderListComponent } from './job-order-list/job-order-list.component';
import { JobOrderFormComponent } from './job-order-form/job-order-form.component';
import { JobOrderFilterComponent } from './job-order-filter/job-order-filter.component';
import { JobOrderDataStateListComponent } from './job-order-data-state-list/job-order-data-state-list.component';
import { JobOrderDataStateFilterComponent } from './job-order-data-state-filter/job-order-data-state-filter.component';
import { JobOrderDetailDialogComponent } from './job-order-detail-dialog/job-order-detail-dialog.component';
import { DepartmentsComponent } from './departments/departments.component';
import { DepartmentInfoComponent } from './department-info/department.info.component';
import { DepartmentTotalJobsComponent } from './department-total-jobs/department.total.jobs.component';
import { DepartmentTotalsComponent } from './department-totals/department.totals.component';
import { DepartmentFilterComponent } from './department-filter/department.filter.component';
import { ErrorListPopupComponent } from './error-list-popup/error-list-popup.component';
import { DocumentationComponent } from './documentation/documentation.component';
import { DateQuickChipsComponent } from './date-quick-chips/date-quick-chips.component';
import { OperationsComponent } from './operations/operations.component';

export const components: any[] = [
  HomeComponent,
  MainComponent,
  LogInComponent,
  ChartComponent,
  CardComponent,
  FilterComponent,
  CustomerComponent,
  MachinesComponent,
  DataStudioReportComponent,
  SettingsComponent,
  UserMngtComponent,
  AgentMngtComponent,
  MachineMngtComponent,
  MachineInfoComponent,
  CustomerMngtComponent,
  MachineTotalsComponent,
  ConfirmDialogComponent,
  AlertDialogComponent,
  UserMngtDetailComponent,
  AgentMngtDetailComponent,
  MachineTotalJobsComponent,
  AgentPwdGenDialogComponent,
  MachineMngtDetailComponent,
  MachineDailyWorksComponent,
  CircularPercentageComponent,
  CustomerMngtDetailComponent,
  OperatorMngtComponent,
  OperatorMngtDetailComponent,
  ViewImgDialogComponent,
  VersionInfoComponent,
  FooterComponent,
  EnvInfoComponent,
  JobOrdersComponent,
  JobOrderDetailComponent,
  JobOrderListComponent,
  JobOrderFormComponent,
  JobOrderFilterComponent,
  JobOrderDataStateListComponent,
  JobOrderDataStateFilterComponent,
  JobOrderDetailDialogComponent,
  DepartmentsComponent,
  DepartmentInfoComponent,
  DepartmentTotalJobsComponent,
  DepartmentTotalsComponent,
  DepartmentFilterComponent,
  ErrorListPopupComponent,
  DocumentationComponent,
  DateQuickChipsComponent,
  OperationsComponent,
];

export * from './home/home.component';
export * from './main/main.component';
export * from './login/login.component';
export * from './chart/chart.component';
export * from './filter/filter.component';
export * from './customer/customer.component';
export * from './machines/machines.component';
export * from './data-studio-report/data-studio-report.component';
export * from './settings/settings.component';
export * from './user-mngt/user-mngt.component';
export * from './agent-mngt/agent-mngt.component';
export * from './machine-info/machine.info.component';
export * from './customer-mngt/customer-mngt.component';
export * from './confirm-dialog/confirm-dialog.component';
export * from './machine-works/machine.daily.works.component';
export * from './machine-total-jobs/machine.total.jobs.component';
export * from './circular-percentage/circular.percentage.component';
export * from './agent-pwd-gen-dialog/agent-pwd-gen-dialog.component';
export * from './view-img-dialog/view-img-dialog.component';
export * from './version-info/version-info.component';
export * from './footer/footer.component';
export * from './env-info/env-info.component';
export * from './departments/departments.component';
export * from './department-info/department.info.component';
export * from './department-total-jobs/department.total.jobs.component';
export * from './department-totals/department.totals.component';
export * from './department-filter/department.filter.component';
export * from './error-list-popup/error-list-popup.component';
export * from './documentation/documentation.component';
export * from './date-quick-chips/date-quick-chips.component';
export * from './operator-mngt/operator-mngt.component';
export * from './operator-mngt-detail/operator-mngt-detail.component';
export * from './operations/operations.component';
